export default "__VITE_ASSET__ChOr84hy__"